import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { addToast } from 'containers/Toasts/actions'

import {
  getPartnerSettingsError,
  getPartnerSettingsSuccess,
  updatePartnerSettingsError,
  updatePartnerSettingsSuccess,
} from './actions'
import { PARTNER_SETTINGS_GET_ASYNC, PARTNER_SETTINGS_UPDATE_ASYNC } from './constants'

const getPartnerSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(PARTNER_SETTINGS_GET_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.getPartnerSettings().pipe(
        map((response) => getPartnerSettingsSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getPartnerSettingsError, error))),
        takeUntil(action$.pipe(ofType(PARTNER_SETTINGS_GET_ASYNC.CANCEL)))
      )
    )
  )

const updatePartnerSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(PARTNER_SETTINGS_UPDATE_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.updatePartnerSettings(state$.value.settings.partnerSettings.data).pipe(
        mergeMap(() =>
          of(
            updatePartnerSettingsSuccess(state$.value.settings.partnerSettings.data),
            addToast({ message: 'Settings was successfully updated' })
          )
        ),
        catchError((error) => of(epicsErrorHandler(updatePartnerSettingsError, error))),
        takeUntil(action$.pipe(ofType(PARTNER_SETTINGS_UPDATE_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(getPartnerSettingsEpic, updatePartnerSettingsEpic)
